import React from "react";
import { IconColor } from "@/shared/ui/Icon";
import { Column, Row } from "@/shared/ui/Blocks";
import { IconName } from "@/shared/ui/Icon";
import { SubtitleText } from "@/shared/ui/Typography";
import IconBadge, { IconBadgeProps } from "../IconBadge";

export interface TitleProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: IconName;
  iconSize?: IconBadgeProps["size"];
  color?: IconColor;
  children: React.ReactNode;
  description?: React.ReactNode;
  className?: string; // New prop for custom class names
  as?: React.ElementType; // New prop for custom title component
}

function Title(props: TitleProps) {
  const {
    children,
    icon,
    iconSize = "sm",
    color,
    description,
    as: TitleComponent = "h2",
    className,
  } = props;

  return (
    <Row className="gap-4 items-center">
      {icon && <IconBadge size={iconSize} icon={icon} color={color} />}
      <Column>
        <TitleComponent className={className}>{children}</TitleComponent>
        {description && <SubtitleText>{description}</SubtitleText>}
      </Column>
    </Row>
  );
}

export { Title };
